import StarterKit from '@tiptap/starter-kit';
//import Image from '@tiptap/extension-image';
import ResizableImage from './ResizableImage';
import { Table } from '@tiptap/extension-table';
import TableRow from '@tiptap/extension-table-row';
import TableHeader from '@tiptap/extension-table-header';
import TableCell from '@tiptap/extension-table-cell';
import TextAlign from '@tiptap/extension-text-align';
import FontFamily from '@tiptap/extension-font-family';
import { TextStyle, Color } from '@tiptap/extension-text-style';
import LineHeight from './LineHeight';
import { Extension } from '@tiptap/core';
import Link from '@tiptap/extension-link';



const FontSize = Extension.create({
  name: 'fontSize',
  addGlobalAttributes() {
    return [
      {
        types: ['textStyle'],
        attributes: {
          fontSize: {
            default: null,
            parseHTML: (element) => element.style.fontSize || null,
            renderHTML: (attributes) => {
              if (!attributes.fontSize) return {};
              return {
                style: `font-size: ${attributes.fontSize}`,
              };
            },
          },
        },
      },
    ];
  },
  addCommands() {
    return {
      setFontSize: (fontSize) => ({ chain }) => {
        return chain()
          .setMark('textStyle', { fontSize })
          .run();
      },
    };
  },
});

const tiptapExtensions = [
  StarterKit.configure({
    paragraph: { HTMLAttributes: { style: '', }, },
    link: false,
  }),
  TextStyle,
  LineHeight,
  FontFamily,
  FontSize,
  Color,
  TextAlign.configure({ types: ['heading', 'paragraph'] }),

  // ✅ 커스텀 이미지 확장으로 교체
  ResizableImage,

  Table.configure({
    resizable: true,
    HTMLAttributes: {
      class: 'custom-table',
      style: 'width: 100%; table-layout: fixed;',
    },
  }),
  TableRow,
  TableHeader,
  TableCell.configure({
    allowTableCellMerge: true,
    HTMLAttributes: {
      class: 'custom-cell',
      style: 'vertical-align: top;',
    },
  }),
  Link.configure({
    openOnClick: true,
    autolink: true,
    linkOnPaste: true,
    HTMLAttributes: {
      rel: 'noopener noreferrer',
      target: '_blank',
      class: 'custom-link',
    },
  }),
];


export default tiptapExtensions;